
import themes from "@/mixins/themes"
import JobFloatingMediaV3 from "@/components/job/jobpage/JobFloatingMediaV3"
import JobGalleryV3 from "@/components/job/jobpage/JobGalleryV3"
import JobContainer from "@/components/job/jobpage/JobContainer"
import intersection from "@/directives/intersection"

export default {
    name: "Section4",
    components: {
        JobFloatingMediaV3,
        JobGalleryV3,
        JobContainer,
    },
    directives: {
        intersection,
    },
    mixins: [themes],
    props: {
        /** Array of images and videos */
        mediaList: {
            type: Array,
            default: () => [],
        },
    },
    inject: ["editorMode"],
    computed: {
        hasMedia() {
            return this.mediaList.length > 0
        },
        spacingClasses() {
            return {
                "eb-pr-10 eb-pr-md-14": this.hasMedia,
            }
        },
    },
    methods: {
        onShowMore(medium) {
            this.$fullscreenMedia.open(this.mediaList, { initialId: medium.id })
        },
    },
}
